/* Scoped enhancements. All shopping links and forms work without this file. */
(() => {
  const openDialog = (dialog, trigger) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog._c101dTrigger = trigger;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDialog = dialog => {
    if (!dialog) return;
    dialog.close();
  };
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-c101d-open]');
    if (open) openDialog(document.getElementById(open.dataset.c101dOpen), open);
    const close = event.target.closest('[data-c101d-close]');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target.matches('dialog.c101d-dialog')) {
      const r = event.target.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(event.target);
    }
    const arrow = event.target.closest('[data-c101d-prev], [data-c101d-next]');
    if (arrow) {
      const track = arrow.closest('[data-c101d-carousel]')?.querySelector('.c101d-product-track');
      if (track) track.scrollBy({left:track.clientWidth * (arrow.hasAttribute('data-c101d-prev') ? -1 : 1), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    const filter = event.target.closest('[data-c101d-filter]');
    if (filter) {
      const panel = document.getElementById(filter.getAttribute('aria-controls'));
      if (panel) filter.setAttribute('aria-expanded', String(panel.classList.toggle('is-open')));
    }
    document.querySelectorAll('.c101d-nav-dropdown[open]').forEach(dropdown => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const dialog = document.querySelector('dialog.c101d-dialog[open]');
      if (dialog) {event.preventDefault();closeDialog(dialog);return;}
      document.querySelectorAll('.c101d-nav-dropdown[open]').forEach(el => {el.open = false;el.querySelector('summary')?.focus();});
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-c101d-sort]')) event.target.form?.requestSubmit();
    if (event.target.matches('[data-c101d-mobile-sort]')) {
      const sort = document.querySelector('[data-c101d-sort]');
      if (sort) {sort.value = event.target.value;sort.form?.requestSubmit();}
    }
  });
  function init(root = document) {
    root.querySelectorAll('dialog.c101d-dialog').forEach(dialog => {
      if (dialog.dataset.c101dReady) return;
      dialog.dataset.c101dReady = 'true';
      dialog.addEventListener('close', () => {
        if (!document.querySelector('dialog.c101d-dialog[open]')) document.documentElement.style.overflow = '';
        dialog._c101dTrigger?.focus();
      });
    });
    root.querySelectorAll('[data-c101d-carousel]').forEach(carousel => {
      if (carousel.dataset.c101dReady) return;
      carousel.dataset.c101dReady = 'true';
      const track = carousel.querySelector('.c101d-product-track');
      const previous = carousel.querySelector('[data-c101d-prev]');
      const next = carousel.querySelector('[data-c101d-next]');
      if (!track || !previous || !next) return;
      const update = () => {previous.disabled = track.scrollLeft < 4;next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;};
      track.addEventListener('scroll', update, {passive:true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('.c101d-collection-links a').forEach(a => {
      if (new URL(a.href,location.href).pathname === location.pathname) a.setAttribute('aria-current','page');
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => {if (!document.querySelector('dialog.c101d-dialog[open]')) document.documentElement.style.overflow = '';});
})();
